export default {
  'questionnaire:check-order': `Check order`,
  'questionnaire:go-to-overview': `To order overview`,
  'questionnaire:next': `Next`,

  'questionnaire:header:in-process-message': `Your order is being processed.`,
  'questionnaire:header:in-processed-message': `Your order has been processed.`,
  'questionnaire:header:error-message': `There was a problem with your order!`,

  'questionnaire:introduction:opening-message': `We would like to get to know you and your furry friend a little better.
  Because you are family! Therefore, we would be very happy
  if you take a moment to answer two questions for us.
  Thank you very much and enjoy your order, your Pets Deli
  Team`,
  'questionnaire:introduction:closing-message': `Thank you for your feedback. We wish you and your
  furry friend much joy with our products.`,
  'questionnaire:introduction:no': 'No thanks',
  'questionnaire:introduction:yes': 'Gladly',

  'questionnaire:breed:loading': 'Loading',
  'questionnaire:breed:no-options-found': 'No options found',

  'questionnaire:input-placeholder': 'Enter here',
};
